import React from "react";

export default function H3(props) {
  return (
    <h1 className="text-lg lg:text-2xl font-medium text-secondary py-2 mb-3">
      {props.children}
    </h1>
  );
}
